// extracted by mini-css-extract-plugin
export default {"title":"styles_title__4BjwE","sidebarVariant":"styles_sidebarVariant__+XZQq","info":"styles_info__udRfi"};